import { TileConfig } from "../../pages/Dashboard/Dashboard.types";

export interface NavMenuGroupConfig {
  id: string;
  title: string;
  tileIds: string[];
}

export type NavRenderItem =
  | { type: "tile"; tile: TileConfig }
  | { type: "group"; group: NavMenuGroupConfig; tiles: TileConfig[] };

// Grouping is a Navbar-only presentational concern, so tiles stay ungrouped
// on the Dashboard - this only changes how useVisibleTiles' output is rendered here.
export const navMenuGroups: NavMenuGroupConfig[] = [
  {
    id: "meter-search",
    title: "Meter Search",
    tileIds: ["electralink-meter-search", "gaslink-meter-search"],
  },
  {
    id: "documents",
    title: "Documents",
    tileIds: ["sales-documents-v2", "proposal-documents"],
  },
  {
    id: "call-data",
    title: "Call Data",
    tileIds: ["transcription", "calls-explorer"],
  },
  {
    id: "administration",
    title: "Administration",
    tileIds: ["tps-bulk-lookup", "admin-users"],
  },
];

// Builds the ordered list of items to render in the navbar, folding any tiles
// that belong to a group into a single group entry (only when at least one of
// its tiles is visible to the current user).
export const buildNavRenderItems = (visibleTiles: TileConfig[]): NavRenderItem[] => {
  const renderedGroupIds = new Set<string>();
  const items: NavRenderItem[] = [];

  visibleTiles.forEach((tile) => {
    const group = navMenuGroups.find((g) => g.tileIds.includes(tile.id));

    if (!group) {
      items.push({ type: "tile", tile });
      return;
    }

    if (renderedGroupIds.has(group.id)) {
      return;
    }
    renderedGroupIds.add(group.id);

    const groupTiles = visibleTiles.filter((t) => group.tileIds.includes(t.id));
    items.push({ type: "group", group, tiles: groupTiles });
  });

  return items;
};
